<template>
    <v-layout align-start justify-start row wrap> 
        <v-flex xs12 class="py-0 mb-0">           
            <span class="red--text py-0 my-0" v-if="errors.collect(attributes.variable,vuexnamespace)">{{ errors.first(attributes.variable, vuexnamespace) }}</span>            
        </v-flex>
        <v-flex xs12>
        <small>{{attributes.hint}} </small></br>
        </v-flex>
        <v-flex d-flex :class="attributes.size">  
                
            <v-text-field            
                :placeholder="attributes.placeholder"                
                solo-inverted
                light  
                flat
                :hint="attributes.hint"
                :prepend-inner-icon="attributes.icon"
                clearable  
                :data-vv-scope="vuexnamespace"
                :data-vv-name="attributes.variable"
                v-validate.immediate="attributes.rules"  
                v-model="result"
            ></v-text-field>   
        </v-flex>
        <v-flex xs1></v-flex> 
        <v-flex :class="attributes.invertedsize"></v-flex>         
    </v-layout>    
</template>

<script>
export default {   
    inject: ['$validator'],
    
    props:[
        'attributes',
        'vuexnamespace'
    ],
    computed: {
        result: {
            get(){
                return this.$store.getters[this.vuexnamespace + '/data'](this.attributes.variable)
            },            
            set(value) {
                if (this.$validator.validateAll())
                    this.$store.commit(this.attributes.setter, value)
            }
        }
        
    },
}
</script>
